// extracted by mini-css-extract-plugin
module.exports = {"box":"CheckboxIcons_box__1M5kW","boxChecked":"CheckboxIcons_boxChecked__3ccwp","checkMarkIcon":"CheckboxIcons_checkMarkIcon__2yYw4"};